module.exports = __webpack_public_path__ + "static/img/huaishuLogo.83ea3d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/huaishuLogo.png
// module id = nr3B
// module chunks = 0